import { useEffect } from 'react';
import { Button } from '@radix-ui/themes';
import { FacebookLogin } from '@capacitor-community/facebook-login';
import type { ProfileSuccessResponse } from '@greatsumini/react-facebook-login';
import { facebookAppId } from 'helpers/facebookAppId';
import { FacebookIcon } from './SocialIcons';

export const CapacitorFacebookLogin: React.FC<{
  setAccessToken: (accessToken: string) => void;
  successFacebookProfileResponse: (response: ProfileSuccessResponse) => void;
  setJwtToken: (jwtToken: string) => void;
}> = ({ successFacebookProfileResponse, setAccessToken, setJwtToken }) => {
  const FACEBOOK_PERMISSIONS = ['email', 'public_profile'];

  useEffect(() => {
    FacebookLogin.initialize({ appId: facebookAppId() ?? '' });
  });

  return (
    <Button
      className='h-10 w-full cursor-pointer rounded-md border-0 bg-[#1877F2]'
      onClick={async () => {
        const result = await FacebookLogin.login({
          permissions: FACEBOOK_PERMISSIONS,
          tracking: 'enabled',
        });
        if (result.accessToken) {
          if (result.accessToken.token.startsWith('EAA')) {
            //web token
            const profile = await FacebookLogin.getProfile({
              fields: ['first_name,last_name,name,email,picture.width(500).height(500),birthday'],
            });

            setAccessToken(result.accessToken.token);
            successFacebookProfileResponse(profile);
          } else if (result.accessToken.token.startsWith('eyJ')) {
            //JWT token
            setJwtToken(result.accessToken.token);
          }
        }
      }}
    >
      <div className='flex items-center justify-center gap-3 text-white'>
        <div>
          <FacebookIcon />
        </div>
        Entra con Facebook
      </div>
    </Button>
  );
};

export default CapacitorFacebookLogin;
